import "./index.scss";
import { EXTERNAL_LINKS, INTERNAL_PATHS } from "routes/paths";
import { handleChatWidget } from "services/window";
import { useAppContext } from "context/app-context";

export const PortalSecondaryFooter = () => {
  const year = new Date().getFullYear();
  const { sessionInfo } = useAppContext();
  const isChatEnabled = Boolean(sessionInfo?.featureToggles?.isZendeskEnabled);
  return (
    <div className="portal-secondary-footer">
      <a
        className="mail-button"
        href={EXTERNAL_LINKS.MARKETPLACE_ZENDESK_NEW_REQUEST}
        target="_blank"
        rel="noreferrer"
      >
        NEED HELP? EMAIL US
      </a>
      <p>
        All content © {year} Raise Marketplace, LLC, GCX and the GCX logo are
        registered trademarks belonging to Raise Marketplace, LLC. All
        trademarks not owned by Raise Marketplace, LLC that appear on this site
        are the property of their respective owners. Raise Marketplace, LLC is
        not the issuer of any of the gift cards or other closed-loop products on
        GCX and is not related to any merchant whose trademarks and gift cards
        appear on GCX for sale.{" "}
        <a href={INTERNAL_PATHS.PRIVACY_POLICY}>Privacy Policy</a>
        {" | "}
        <a href={INTERNAL_PATHS.TERMS_OF_USE}>Terms of Use</a>
        {" | "}
        This site contains affiliate links for which GCX may be compensated:{" "}
        <a href={INTERNAL_PATHS.FTC_DISCLOSURE}>FTC Disclosure</a>
      </p>
      {isChatEnabled && (
        <p>
          <button type="button" onClick={handleChatWidget}>
            Chat with us
          </button>{" "}
          for any gift card redemption questions.
        </p>
      )}
    </div>
  );
};
